import { render } from "./FileManage.vue?vue&type=template&id=eccbeff2&scoped=true"
import script from "./FileManage.vue?vue&type=script&lang=js"
export * from "./FileManage.vue?vue&type=script&lang=js"

import "./FileManage.vue?vue&type=style&index=0&id=eccbeff2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-eccbeff2"]])

export default __exports__